import React, { memo } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "./index.module.scss";

const CommonCarousel = ({
  children,
  showStatus,
  selectedItem,
  showArrows,
  showIndicators,
  setActiveSlideIndex,
}: any) => {
  return (
    <Carousel
      showStatus={showStatus}
      showThumbs={false}
      showIndicators={showIndicators}
      showArrows={showArrows}
      selectedItem={selectedItem}
      onChange={(index) => setActiveSlideIndex(index)}
      autoPlay={false}
    >
      {children}
    </Carousel>
  );
};

export default memo(CommonCarousel);
